import { DepartmentDto } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class DepartmentResponseModel extends GlobalResponseObject{
    data?: DepartmentDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //DepartmentDto
     */
     constructor(status: boolean, errorCode: number, internalMessage: string, data?: DepartmentDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
